import { createModulePlaceholderPage } from "../ModulePlaceholderPage";
import { BUILDING_MANAGEMENT_MODULES } from "../modules";

const module = BUILDING_MANAGEMENT_MODULES.find((m) => m.id === "schedule")!;

export default createModulePlaceholderPage(module);
